module.exports = __webpack_public_path__ + "static/vityazPrivatbank-e0c77fbe59762068bb417efb152a0696.png";